import type {OptionStatusIndicator} from 'platform/components';

import type {UserResponseBody} from '@dms/api/shared';
import i18n from '@dms/i18n';

import type {Nullish} from 'shared/web';

import {isUserInactive} from './isUserInactive';

// Resolves the status indicator shown on a user picker option. A persisted
// inactive (deleted) user gets a "deleted" tooltip; everyone else keeps the
// caller's absence indicator. The two never collide: absence is only computed
// for active users, so an inactive user never has an absence indicator to lose.
export const getUserStatusIndicator = (
  user: UserResponseBody,
  absenceIndicator: OptionStatusIndicator | Nullish
) =>
  isUserInactive(user)
    ? {tooltip: i18n.t('entity.user.labels.deletedUser')}
    : (absenceIndicator ?? undefined);
